const { newsArtifactsTypes } = require('shared/constants/artifactTypes');

export const productLineByAnnoucementType = {
  [newsArtifactsTypes.COMMENTARY]: 'Research',
  [newsArtifactsTypes.RATING_NEWS]: 'Rating',
  [newsArtifactsTypes.RESEARCH]: 'Research',
  [newsArtifactsTypes.MONITORING_NOTES]: 'Research',
};
